
'use client'

import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "./ua.module.scss";
import Field from "@/components/form/Field";
import Form from "@/components/form/Form";
import Icon from "@/components/icon/Icon";
import { useRouter } from "next/navigation";
import { genInvUrl, getFiltersFromParams } from "@/data/Inventory";
import ApiUtils from "@/utils/ApiUtils";
import debounce from "lodash.debounce";
import Dropdown from "@/components/dropdown/Dropdown";

export default function SearchField(props) {
  
  const router = useRouter()
  const [term,setTerm] = useState(props.filters?.term || '')
  const [salt,setSalt] = useState(new Date().getTime())
  const [taData, setTaData] = useState([])

  const taDropdown = useRef()
  
  useEffect(() => {
    setTerm(props.filters?.term)
    setSalt(new Date().getTime())
  }, [props.filters?.term])
  
  const onChange = (value) => {
    const searchTerm = value.replace(/[^\x00-\x7F]/gu, "")
    if (searchTerm && searchTerm != '') {
      setTerm(searchTerm)
      if (searchTerm) {
        debouncedYmmtSearch(searchTerm)
      } else {
        setTaData([])
        taDropdown.current.hide(null, true)
        setTimeout(() => {
          taDropdown.current.hide(null, true)
        }, 1000)
      }
    }
  }

  const ymmtSearch = (q) => {
    ApiUtils.getRequest("/api/ymmt?q=" + q)
    .then(data => {
      let yearList = []
      let makeList = []
      let modelList = []
      let allMakeList = []
      let allModelList = []
      const qParts = q.split(" ")
      data.map(item => {
        qParts.map(p => {
          if ((item.year + "").match(new RegExp(p, "i"))) {
            yearList.push(item)
          }
          if ((item.make + "").match(new RegExp(p, "i"))) {
            makeList.push(item)
          }
          if ((item.model + "").match(new RegExp(q, "i"))) {
            modelList.push(item)
          } else if ((item.model + "").match(new RegExp(p, "i"))) {
            modelList.push(item)
          }
          allMakeList.push(item)
          allModelList.push(item)
        })
      })
      let list = []
      let listData = {}
      if (yearList.length > 0) {
        yearList.map(y => {
          if (makeList.length > 0) {
            makeList.map(mk => {
              if (modelList.length > 0) {
                modelList.map(md => {
                  if (!list.includes(y + ' ' + mk.make + ' ' + md.model) && mk.year == y && md.year == y && md.make == mk.make) {
                    list.push(y + ' ' + mk.make + ' ' + md.model)
                    listData[y + ' ' + mk.make + ' ' + md.model] = { label: y + ' ' + mk.make + ' ' + md.model, year: y, make: mk.make, model: md.model }
                  }
                })
              } else {
                if (!list.includes(y + ' ' + mk.make) && mk.year == y) {
                  list.push(y + ' ' + mk.make)
                  listData[y + ' ' + mk.make] = { label: y + ' ' + mk.make, year: y, make: mk.make }
                }
              }
            })
          } if (modelList.length > 0) {
            modelList.map(md => {
              if (!list.includes(y + ' ' + md.model) && md.year == y) {
                list.push(y + ' ' + md.model)
                listData[y + ' ' + md.model] = { label: y + ' ' + md.model, year: y, model: md.model }
              }
            })
          } else {
            if (!list.includes(y.year + "")) {
              list.push(y.year + "")
              listData[y.year + ""] = { label: y.year, year: y.year }
            }
          }
        })
        if (list.length == 1) {
          allMakeList.map(mk => {
            const y = list[0]
            if (!list.includes(y + ' ' + mk.make) && mk.year == y) {
              list.push(y + ' ' + mk.make)
              listData[y + ' ' + mk.make] = { label: y + ' ' + mk.make, year: y, make: mk.make }
            }
          })
        }
      } else if (makeList.length > 0) {
        makeList.map(mk => {
          if (modelList.length > 0) {
            modelList.map(md => {
              if (!list.includes(mk.make + ' ' + md.model) && md.make == mk.make) {
                list.push(mk.make + ' ' + md.model)
                listData[mk.make + ' ' + md.model] = { label: mk.make + ' ' + md.model, make: mk.make, model: md.model }
              }
            })
          } else {
            if (!list.includes(mk.make)) {
              list.push(mk.make)
              listData[mk.make] = { label: mk.make, make: mk.make }
            }
          }
        })
        if (list.length == 1) {
          allModelList.map(md => {
            const mk = list[0]
            if (!list.includes(mk + ' ' + md.model) && md.make == mk) {
              list.push(mk + ' ' + md.model)
              listData[mk + ' ' + md.model] = { label: mk + ' ' + md.model, make: mk, model: md.model }
            }
          })
        }
      } else if (modelList.length > 0) {
        modelList.map(md => {
          if (!list.includes(md.model)) {
            list.push(md.model)
            listData[md.model] = { label: md.model, model: md.model }
          }
        })
      }
      list = list.slice(0,10)
      let taList = []
      list.map(e => {
        taList.push(listData[e])
      })
      console.log(taList)
      setTaData(taList)
      if (taList.length > 0) {
        taDropdown.current.show()
      }
    })
  }

  const debouncedYmmtSearch = useMemo(() => debounce(ymmtSearch, 500), [])

  const onTASelect = (e, item) => {
    e.preventDefault()
    let filter = {}
    if (item.year) filter.year = [item.year]
    if (item.make) filter.brand = [item.make]
    if (item.model) filter.model = item.model
    setTerm(Object.values(filter).join(' '))
    if (props.listingRef) {
      props.listingRef.current.applyFilters(filter)
      taDropdown.current.hide(null, true)
    } else {
      const pageFilters = Object.assign(getFiltersFromParams(props), props.filters || {})
      delete pageFilters['term']
      let url = genInvUrl(pageFilters, {})
      if (url.indexOf("?") >= 0) url += ""
      else url += "?"
      if (item.year) url += "&year=" + item.year
      if (item.make) url += "&brand=" + item.make
      if (item.model) url += "&model=" + item.model
      router.push(url)
    }
  }

  const onBlur = (e) => {
    taDropdown.current.hide(e)
  }
  
  const onSubmit = (e) => {
    const pageFilters = Object.assign(getFiltersFromParams(props), props.filters || {})
    delete pageFilters['term']
    let url = genInvUrl(pageFilters, {})
    if (url.indexOf("?") >= 0) url += "&"
    else url += "?"
    router.push(url + "term=" + term)
  }
  
  return <Form onSubmit={e => onSubmit(e)} id={ props.formId } name={ props.searchPlaceholder || 'Find Your Car' }>
    <Field id={props.id} key={salt} name="term" type="text" value={term} onChange={value => onChange(value)} onBlur={e => onBlur(e)} placeholder={props.searchPlaceholder || 'Find Your Car by Make, Model or Keyword'}></Field>
    <Icon {...props} name="search"></Icon>
    <Dropdown {...props} key="ta" ref={taDropdown} position={'ta'} offset={'4px'}>
      <div className={styles.ta}>
      { taData.map((item,index) => (
        <a key={index} tabIndex={0} aria-label={ item.label } onClick={e => onTASelect(e, item)}>{ item.label }</a>
      ))}
      </div>
    </Dropdown>
  </Form>

}